
export default {
  SendCaptcha: 'Notice/SMS.SendCaptcha',
  SendEmailCaptcha: 'Notice/EMail.SendCaptcha',
}